<div class="relative flex h-full w-full flex-col">
  <div class="rounded border border-gray-200 bg-gray-50 px-3 py-3 text-sm">
    <p>{{ 'vehicleSelection.hint.vinKba.text' | transloco }}</p>
    <table class="mt-2 border-separate border-spacing-y-1">
      <tr class="align-top">
        <td>
          <strong class="whitespace-nowrap">{{ 'vehicleSelection.hint.vinKba.mercedes' | transloco }}</strong>
        </td>
        <td class="pl-2">{{ 'vehicleSelection.hint.vinKba.mercedesHint' | transloco }}</td>
      </tr>
      <tr class="align-top">
        <td>
          <strong class="whitespace-nowrap">{{ 'vehicleSelection.hint.vinKba.vw' | transloco }}</strong>
        </td>
        <td class="pl-2">{{ 'vehicleSelection.hint.vinKba.vwHint' | transloco }}</td>
      </tr>
      <tr class="align-top">
        <td>
          <strong class="whitespace-nowrap">{{ 'vehicleSelection.hint.vinKba.others' | transloco }}</strong>
        </td>
        <td class="pl-2">{{ 'vehicleSelection.hint.vinKba.othersHint' | transloco }}</td>
      </tr>
      <tr class="align-top">
        <td>
          <strong class="whitespace-nowrap">{{ 'vehicleSelection.hint.vinKba.errorCode' | transloco }}</strong>
        </td>
        <td class="pl-2">{{ 'vehicleSelection.hint.vinKba.errorCodeHint' | transloco }}</td>
      </tr>
    </table>
  </div>

  @if (error() === 'global') {
    <div class="mt-2 rounded border border-red-500 bg-red-100 px-3 py-3 text-sm">{{ 'vehicleSelection.exception' | transloco }}</div>
  }

  <div class="mt-8 flex-1">
    <p class="text-sm font-semibold">{{ 'vehicleSelection.label.vinKba' | transloco }}</p>
    <div class="relative mt-2">
      <p-autocomplete
        #autocomplete
        class="w-full"
        inputStyleClass="w-full py-2 !pr-12"
        [(ngModel)]="inputValue"
        [suggestions]="foundVehicles()"
        [minQueryLength]="6"
        [delay]="300"
        [invalid]="isInvalid()"
        appendTo="body"
        inputId="vinInput"
        (completeMethod)="findVehicles($event)"
        (onSelect)="handleSelect()"
        (onKeyUp)="onKeyUp($event)"
        (onFocus)="onInputFocus()"
        optionLabel="name"
        [overlayOptions]="{ style: { maxWidth: '80dvw' } }"
        [placeholder]="'vehicleSelection.vin-kba-placeholder' | transloco"
        data-testid="vin-kba-input">
        <ng-template #empty>
          @if (isLoading()) {
            <div class="px-3 py-3">{{ 'global.loading' | transloco }}</div>
          } @else if (error() === 'global') {
            <div class="flex items-center gap-2 px-3 py-3 text-red-500">
              <i class="pi pi-exclamation-triangle !text-lg"></i>
              {{ 'vehicleSelection.error.search' | transloco }}
            </div>
          } @else if (error() === 'format') {
            <div class="px-3 py-0 text-sm">
              @if (isTooLong()) {
                {{ 'vehicleSelection.error.tooLong' | transloco }}
              } @else {
                {{ 'vehicleSelection.error.invalidFormat' | transloco }}
              }
            </div>
          } @else {
            <div class="px-3 py-0 text-sm">{{ 'global.empty' | transloco }}</div>
          }
        </ng-template>
        <ng-template let-vehicle #item>
          <div class="w-full whitespace-normal text-sm max-sm:border-b max-sm:border-gray-200 max-sm:pb-2" data-testid="autocomplete-vehicle">
            <strong>{{ vehicle.name }}</strong>
            <div>{{ vehicle.engineCode }}, {{ vehicle.capacity }}, {{ vehicle.output }}, {{ vehicle.madeFrom }} - {{ vehicle.madeUntil }}</div>
          </div>
        </ng-template>
      </p-autocomplete>

      <p-button
        *ngIf="autocomplete.inputValue()?.length > 2 && !isLoading()"
        icon="pi pi-times"
        class="absolute right-2 top-[6px]"
        [text]="true"
        size="small"
        severity="contrast"
        (click)="clear()" />
    </div>

    <div class="mb-4 mt-12 flex w-full justify-end">
      <p-button
        #submitButtonVinKba
        severity="contrast"
        [label]="'vehicleSelection.mainBtnText' | transloco"
        size="large"
        (click)="onFinishSelection()"
        [disabled]="!selectedVehicle()"
        class="px-1"></p-button>
    </div>
  </div>
</div>
